import React, { useState, useEffect } from 'react';
import { CommonHash } from 'app/types';
import MDEditor from '@uiw/react-md-editor';

import Text from 'common/components/Text/Text';

import styles from '../LandingForm.module.scss';
import SubLandingComponentForm from '../SubLandingComponentForm';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

interface ComponentFormProps {
  landing_cmp: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  index: number;
}

const ContentGridForm = ({
  landing_cmp,
  handleChange,
  index,
}: ComponentFormProps): React.ReactElement => {
  const [markdownText, setMarkdownText] = useState(landing_cmp['config'].description || '');
  useEffect(() => {
    handleChange({
      target: {
        name: `landing_components[${index}].config['description']`,
        value: markdownText,
      },
    });
  }, [markdownText]);

  return (
    <>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['title']`}>Title</label>
        <input
          name={`landing_components[${index}].config['title']`}
          placeholder="Title"
          onChange={handleChange}
          defaultValue={landing_cmp.config.title || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['section_title']`}>
          Section title
        </label>
        <input
          name={`landing_components[${index}].config['section_title']`}
          placeholder="Section title"
          onChange={handleChange}
          defaultValue={landing_cmp.config.section_title || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['description']`}>
          Content Grid Description
        </label>
        <MDEditor value={markdownText} onChange={setMarkdownText} />
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownText}</ReactMarkdown>
      </div>
      <Text size={22} weight={600} inlineStyle={{ marginTop: '20px', marginBottom: '10px' }}>
        Tabs
      </Text>
      <SubLandingComponentForm
        name={`landing_components[${index}].sub_landing_components`}
        landing_component={landing_cmp}
        handleChange={handleChange}
        limit={100}
        sub_component={'tab'}
        component_name={'Tab'}
      />
    </>
  );
};

export default ContentGridForm;
